<template>
    <div>
        <div class="table-header row">
            <div>
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
            </div>
            <div>
                服务器标签名
            </div>
            <div>
                标签使用情况
            </div>
            <div>操作</div>
        </div>
        <div class="table-body">
            <div
                class="row"
                v-for="(item, index) in serverLabelList"
                :key="index"
            >
                <!-- 选中 -->
                <div>
                    <input
                        type="checkbox"
                        @click.stop
                        v-model="item.select"
                        @change="selectChange(item.select)"
                    />
                </div>
                <!-- 服务器标签名 -->
                <div>
                    <span
                        v-text="$PropFn.safeDislayValue(item.labelName)"
                    ></span>
                </div>
                <!-- 标签使用情况 -->
                <div>
                    <span v-text="item.useNum"></span>
                    <span>台</span>
                </div>
                <div class="operate">
                    <a href="#" @click.prevent.stop="editServerName(item)"
                        >修改名称</a
                    >
                    <a href="#" @click.prevent.stop="chooseServer(item)"
                        >选择服务器应用</a
                    >
                    <a href="#" @click.prevent.stop="delServerName(item)"
                        >删除</a
                    >
                </div>
            </div>
            <div style="font-size: 12px;color: #A1A1A1;">
                最多可设置20条标签
            </div>
            <no-data
                style="height:auto;padding-top:20px;padding-bottom:20px;"
                v-show="tableList.length == 0 || loading"
                :nodata="tableList.length == 0 && !loading"
                :loading="loading"
            ></no-data>
        </div>
        <div class="table-pagination" v-show="tableList.length > 0">
            <div style="float:left;padding-left:10px;">
                <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="selectAllChange"
                />
                <div
                    class="default-btn"
                    style="margin-left:10px;cursor: pointer;"
                    @click.prevent="deleteAllLabel"
                >
                    <span>删除</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NoData from "_c/noData/noData";
// import { mapState } from 'vuex';

import { delLabelName } from "@/requests/bar";
export default {
    name: "tableData",
    components: {
        NoData
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isSelectAll: false,
            serverLabelList: []
        };
    },
    watch: {
        tableList() {
            this.isSelectAll = false;
            this.serverLabelList = this.tableList.map(item => {
                item.select = false;
                return item;
            });
        }
    },
    methods: {
        selectedLabelIds() {
            let arr = [];
            this.serverLabelList.forEach(item => {
                if (item.select) {
                    arr.push(item.labelId);
                }
            });
            return arr;
        },
        selectAllChange() {
            if (this.isSelectAll) {
                this.serverLabelList.forEach(item => {
                    item.select = true;
                });
            } else {
                this.serverLabelList.forEach(item => {
                    item.select = false;
                });
            }
        },
        selectChange(selectState) {
            if (selectState) {
                // 对单项进行选中
                // 判断是否全部选中
                let selectAllState = this.serverLabelList.every(item => {
                    return item.select == true;
                });
                // 若全部选中,则为全选状态
                if (selectAllState) {
                    this.isSelectAll = true;
                }
            } else {
                // 对单项进行取消
                this.isSelectAll = false;
            }
        },
        async editServerName(item) {
            let res = await window.$modal.editServerLabel.show(
                item.labelId,
                item.labelName
            );
            if (res) {
                this.$emit("refresh");
            }
        },
        async chooseServer(item) {
            let res = await window.$modal.serverApplication.show(item.labelId);
            if (res) {
                this.$emit("refresh");
            }
        },
        delServerName(item) {
            window.$Message.show({
                title: "删除服务器标签",
                type: "success",
                msg:
                    '是否删除服务器标签"' +
                    item.labelName +
                    '" ? 若有服务器正在使用该标签，则会恢复成"无标签"。',
                cancleBtn: true,
                confirmFn: () => {
                    this.del(item);
                    window.$Message.hide();
                }
            });
        },
        async del(item) {
            let res = await delLabelName({
                labelId: item.labelId
            });
            if (res.code == 200) {
                this.$emit("refresh");
            } else {
                window.$Message.show({
                    title: "删除服务器标签",
                    type: "error",
                    msg: res.msg
                });
            }
        },
        deleteAllLabel() {
            this.$emit("deleteAllLabel");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
    width: 100%;
    cursor: pointer;
    @include clearfix();
    &:after {
        content: "";
        top: 0;
        left: 0;
        display: block;
        font-size: 0;
        height: 0;
        width: 0;
        clear: both;
        visibility: hidden;
    }
    > div {
        float: left;
        text-align: left;
        text-overflow: ellipsis;
        height: 50px;
        span {
            @include ellipsis();
            display: inline-block;
            max-width: 100%;
        }
        p {
            @include ellipsis();
            max-width: 100%;
        }
        a {
            text-align: left;
            text-indent: 0px;
            margin-right: 8px;
            color: #0066cc;
        }
        input {
            cursor: pointer;
        }
    }

    > div:nth-child(1) {
        width: 4%;
        text-indent: 10px;
        input {
            position: relative;
            top: 2px;
        }
    }
    > div:nth-child(2) {
        width: 30%;
    }
    > div:nth-child(3) {
        width: 30%;
    }
    > div:nth-child(4) {
        width: 36%;
    }
}

.table-header {
    > div {
        height: 30px;
        line-height: 30px;
    }
}

.bar-name {
    p {
        line-height: normal;
        line-height: 14px;
    }
    p:nth-child(1) {
        padding-top: 10px;
    }
}
.gray-word {
    color: $gray-word;
}
.server {
    .online {
        span {
            color: $green;
        }
    }
    .offline {
        span {
            color: $gray-word;
        }
    }
    img {
        position: relative;
        vertical-align: top;
        top: 18px;
        margin-right: 4px;
    }
}

.table-pagination {
    text-align: right;
    padding-right: 80px;
    padding-top: 20px;
    > div {
        display: inline-block;
    }
}
input[type="checkbox"] {
    cursor: pointer;
}
</style>
